package co.uk.sacursoftware.ssinventory.data.repository

import co.uk.sacursoftware.ssinventory.data.model.StockCountItem
import co.uk.sacursoftware.ssinventory.util.KeyValueStorage
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json

class DraftRepository {
    private val storage = KeyValueStorage()
    private val json = Json { ignoreUnknownKeys = true }

    fun saveDraft(supplierId: String, items: List<StockCountItem>) {
        val key = "draft_stock_count_$supplierId"
        val data = json.encodeToString(items)
        storage.putString(key, data)
    }

    fun loadDraft(supplierId: String): List<StockCountItem>? {
        val key = "draft_stock_count_$supplierId"
        val data = storage.getString(key) ?: return null
        return try {
            json.decodeFromString<List<StockCountItem>>(data)
        } catch (e: Exception) {
            null
        }
    }

    fun clearDraft(supplierId: String) {
        val key = "draft_stock_count_$supplierId"
        storage.remove(key)
    }
}
